var _defs, _text, _g, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2666.7 2000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 1500h2e3v-1500h-2e3z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 2e3)"
  }, _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 -1 647.13 361)",
    fill: "#414142",
    fontFamily: "'Open Sans Semibold'",
    fontSize: "61.43px",
    fontWeight: 600,
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.3824 0 0 2.3824 -1370.7 -1341.2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1146.8 955.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c13.049-36.561 23.315-67.579 32.479-94.793 68.267 78.93 124.76 160.61 145.35 196.42h-160.73s28.893-18.119 14.863-42.441c-10.386-16.544-17.881-28.25-34.697-52.444 0.911-2.242 1.901-4.408 2.729-6.74",
    fill: "#004282"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(712.45 748.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-32.172 44.65-26.771 120.06 6.193 174.82 49.392 82.051 144.97 131.24 220.77 137.06v-50.208c-158.05-39.308-237.57-255.89-136.75-311.13-37.03 0-73.174 25.793-90.22 49.449",
    fill: "#004282"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1324.6 661.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0s-149.21-74.104-209.04 71.409c-5.361 13.049-15.379 42.55-15.956 44.247-2.294 6.748-52.894 167.94-71.426 199.89-3.402 5.882-7.189 10.943-11.285 15.294v65.822c50.364-11.699 91.66-44.131 111.1-98.569 41.735-116.89 54.981-177.21 94.671-237.17 33.898-51.195 101.94-60.919 101.94-60.919",
    fill: "#004282"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(954.81 1130.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h64.592v-301.12l-0.671-0.72c-19.212-20.613-38.754-39.861-59.744-58.846l-4.177-3.777z",
    fill: "#02953f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(838.28 705.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-14.232 0-25.827 3.72-35.447 11.371-2.573 2.059-5.063 4.513-7.401 7.294l-0.587 0.697v122.19h64.592v-138.92l-1.966-0.43c-6.543-1.431-12.721-2.171-18.362-2.201z",
    fill: "#02953f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(874.83 945.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h64.59v-193.55l-0.906-0.75c-19.922-16.484-40.76-29.294-60.26-37.046l-3.424-1.362z",
    fill: "#02953f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1085.6 765.85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.108 3.26-13.487 42.556-28.079 85.914-4.57-5.585-12.09-14.763-12.416-15.173-203.95-256.62-361.12-133.98-368.86-39.625-7.28-79.26 31.524-134.34 97.546-154.98 100.89-31.536 222.23 28.547 312.76 121.07-0.521 1.522-0.859 2.519-0.952 2.791",
    fill: "#004282"
  }))))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.75 0 0 -.75 0 1500)",
    fill: "#000000",
    style: {
      shapeInside: "url(#rect324)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.75 0 0 -.75 0 1500)",
    fill: "#000000",
    style: {
      shapeInside: "url(#rect362)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.75 0 0 -.75 0 1500)",
    fill: "#000000",
    style: {
      shapeInside: "url(#rect784)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    transform: "scale(1,-1)",
    cx: 731.34,
    cy: -833.96,
    r: 0.93923,
    fill: "#004282",
    stroke: "#000",
    strokeWidth: 0.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    transform: "scale(1,-1)",
    cx: 731.34,
    cy: -833.96,
    r: 0.93923,
    fill: "#004282",
    stroke: "#000",
    strokeWidth: 0.75
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    transform: "scale(1,-1)",
    cx: 731.34,
    cy: -833.96,
    r: 0.93923,
    fill: "#004282",
    stroke: "#000",
    strokeWidth: 0.75
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2e584e2336be271159c83ed602220239.svg";
export { ForwardRef as ReactComponent };